import { render, staticRenderFns } from "./NewsChange.vue?vue&type=template&id=6e97beb9&scoped=true&"
import script from "./NewsChange.vue?vue&type=script&lang=js&"
export * from "./NewsChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e97beb9",
  null
  
)

export default component.exports